import { SYSTEM_ERROR } from "../../src/config/CONSTANT";
import axios from "axios";
import { GET_Announcements } from "../../src/services/CONSTANTS";
export const getAllAnnouncements = () => {
  return new Promise((resolve, reject) => {
    try {
      axios
        .get(GET_Announcements())
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("Error in getAllMarshalls axios!");
        });
    } catch (error) {
      console.error("in marshallsServices > getAllMarshalls, Err===", error);
      reject(SYSTEM_ERROR);
    }
  });
};
